import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class FileHttpService {
  private httpClient = inject(HttpClient);

  private baseUrl = `${environment.cmiApiUri}`;

  getFile(subLobTemplateId: number, filename: string): Observable<Blob> {
    const encodedFilename = filename == null ? '' : encodeURIComponent(filename);
    const url = `${this.baseUrl}/api/file/${subLobTemplateId}/${encodedFilename}`;

    return this.httpClient.get(url, { responseType: 'blob' });
  }
}
